/**
 * Created by Pankaj on 07-May-2020
 */
import {ISymbolPositions} from "../winpresentation/geniefeature/GenieFeatureController";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TweenLite} from "gsap";


export class FinalMultiplier extends PIXI.Container {

    private _multiplierText: PIXI.BitmapText;
    private _multiplier: number;
    private _isActive: boolean = false;
    private _sourceSymId: number;

    constructor(value: number, pos: number[]) {
        super();
        this.init(value, pos);
    }

    private init(multiplier: number, pos: number[]) {
        this.createRays();
        this.createMultiplier(multiplier);
        this.position.set(pos[0], pos[1]);
    }

    public show(): TweenLite {
        this.isActive = true;
        return TweenLite.fromTo(this, 0.2, {alpha: 0}, {alpha: 1});
    }

    private createRays() {
        const multiplierRays = this.createSprite("multiplierRays", undefined);
        multiplierRays.anchor.set(0.5, 0.5);
        multiplierRays.playLoop();
        multiplierRays.show();
        this.addChild(multiplierRays);
    }

    private createMultiplier(multiplier: number): PIXI.BitmapText {
        let multiplierText: PIXI.BitmapText = this.createBitmapText("x" + multiplier, undefined, "center", 28);
        multiplierText.anchor = 0.5;
        multiplierText.y = -25;
        this._multiplierText = multiplierText;
        this.addChild(multiplierText);
        return multiplierText;
    }

    /**
     * To create Text from Bitmap font images
     * */
    private createBitmapText(text: string, position?: ISymbolPositions | number[], align?: string, size?: number): PIXI.BitmapText {
        const bitmapText: PIXI.BitmapText = new PIXI.BitmapText(text, {
            fontName: "NumbersWinCountUp",
            fontSize: size || 22,
            align: align || "center",
            tint: parseInt(("#ffffff").replace(/^#/, ''), 16)
        });
        if (position) {
            position = position instanceof Array ? position : Helper.getSymbolPositions(position.reelId, position.symbolId);
            bitmapText.position.set(position[0], position[1]);
        }
        return bitmapText;
    }

    private createSprite(texture: string, position?: ISymbolPositions | number[], sourceFPS?: number, parent?: PIXI.Container): TimelineSprite {
        const textures: PIXI.Texture[] = GameResources.getTextures(texture);
        const sprite: TimelineSprite = new TimelineSprite(textures, sourceFPS);
        sprite.anchor.set(0.5, 0.5);
        if (position) {
            position = position instanceof Array ? position : Helper.getSymbolPositions(position.reelId, position.symbolId);
            sprite.position.set(position[0], position[1]);
        }
        parent && parent.addChild(sprite);
        return sprite;
    }

    public hide(): TweenLite {
        this.isActive = false;
        return TweenLite.to(this.scale, 0.3, {
            x: 0, y: 0,
            onComplete: () => {
                this.removeChildren();
            }
        });
    }

    get multiplier(): number {
        return this._multiplier;
    }

    set multiplier(value: number) {
        this._multiplier = value;
        this._multiplierText.text = "x"+value;
    }

    get isActive(): boolean {
        return this._isActive;
    }

    set isActive(value: boolean) {
        this._isActive = value;
    }

    get sourceSymId(): number {
        return this._sourceSymId;
    }

    set sourceSymId(value: number) {
        this._sourceSymId = value;
    }
}